export default {
    props: {
        shapeDefaultsConnectors: {
            type: Array,
            default: undefined,
            kComposite: 'shapeDefaults.connectors'
        },         shapeDefaultsConnectorDefaultsWidth: {
            type: Number,
            default: undefined,
            kComposite: 'shapeDefaults.connectorDefaults.width'
        }, 
        shapeDefaultsConnectorDefaultsHeight: {
            type: Number,
            default: undefined,
            kComposite: 'shapeDefaults.connectorDefaults.height'
        }, 
        shapeDefaultsConnectorDefaultsHoverFill: {
            type: String,
            default: undefined,
            kComposite: 'shapeDefaults.connectorDefaults.hover.fill'
        }, 
        shapeDefaultsConnectorDefaultsHoverFillColor: {
            type: String,
            default: undefined,
            kComposite: 'shapeDefaults.connectorDefaults.hover.fill.color'
        }, 
        shapeDefaultsConnectorDefaultsHoverFillOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'shapeDefaults.connectorDefaults.hover.fill.opacity'
        }, 
        shapeDefaultsConnectorDefaultsHoverStroke: {
            type: String,
            default: undefined,
            kComposite: 'shapeDefaults.connectorDefaults.hover.stroke'
        }, 
        shapeDefaultsConnectorDefaultsHoverStrokeColor: {
            type: String,
            default: undefined,
            kComposite: 'shapeDefaults.connectorDefaults.hover.stroke.color'
        }, 
        shapeDefaultsConnectorDefaultsHoverStrokeDashType: {
            type: String,
            default: undefined,
            kComposite: 'shapeDefaults.connectorDefaults.hover.stroke.dashType'
        }, 
        shapeDefaultsConnectorDefaultsHoverStrokeWidth: {
            type: Number,
            default: undefined,
            kComposite: 'shapeDefaults.connectorDefaults.hover.stroke.width'
        }, 
        shapeDefaultsConnectorDefaultsFill: {
            type: String,
            default: undefined,
            kComposite: 'shapeDefaults.connectorDefaults.fill'
        }, 
        shapeDefaultsConnectorDefaultsFillColor: {
            type: String,
            default: undefined,
            kComposite: 'shapeDefaults.connectorDefaults.fill.color'
        }, 
        shapeDefaultsConnectorDefaultsFillOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'shapeDefaults.connectorDefaults.fill.opacity'
        }, 
        shapeDefaultsConnectorDefaultsStroke: {
            type: String,
            default: undefined,
            kComposite: 'shapeDefaults.connectorDefaults.stroke'
        }, 
        shapeDefaultsConnectorDefaultsStrokeColor: {
            type: String,
            default: undefined,
            kComposite: 'shapeDefaults.connectorDefaults.stroke.color'
        }, 
        shapeDefaultsConnectorDefaultsStrokeDashType: {
            type: String,
            default: undefined,
            kComposite: 'shapeDefaults.connectorDefaults.stroke.dashType'
        }, 
        shapeDefaultsConnectorDefaultsStrokeWidth: {
            type: Number,
            default: undefined,
            kComposite: 'shapeDefaults.connectorDefaults.stroke.width'
        }, 
        shapeDefaultsContent: {
            type: Object,
            default: undefined,
            kComposite: 'shapeDefaults.content'
        }, 
        shapeDefaultsContentAlign: {
            type: String,
            default: undefined,
            kComposite: 'shapeDefaults.content.align'
        }, 
        shapeDefaultsContentColor: {
            type: String,
            default: undefined,
            kComposite: 'shapeDefaults.content.color'
        }, 
        shapeDefaultsContentFontFamily: {
            type: String,
            default: undefined,
            kComposite: 'shapeDefaults.content.fontFamily'
        }, 
        shapeDefaultsContentFontSize: {
            type: Number,
            default: undefined,
            kComposite: 'shapeDefaults.content.fontSize'
        }, 
        shapeDefaultsContentFontStyle: {
            type: String,
            default: undefined,
            kComposite: 'shapeDefaults.content.fontStyle'
        }, 
        shapeDefaultsContentFontWeight: {
            type: String,
            default: undefined,
            kComposite: 'shapeDefaults.content.fontWeight'
        }, 
        shapeDefaultsContentTemplate: {
            type: [String, Function],
            default: undefined,
            kComposite: 'shapeDefaults.content.template'
        }, 
        shapeDefaultsContentText: {
            type: String,
            default: undefined,
            kComposite: 'shapeDefaults.content.text'
        }, 
        shapeDefaultsEditable: {
            type: Boolean,
            default: undefined,
            kComposite: 'shapeDefaults.editable'
        }, 
        shapeDefaultsEditableConnect: {
            type: Boolean,
            default: undefined,
            kComposite: 'shapeDefaults.editable.connect'
        }, 
        shapeDefaultsEditableDrag: {
            type: Boolean,
            default: undefined,
            kComposite: 'shapeDefaults.editable.drag'
        }, 
        shapeDefaultsEditableRemove: {
            type: Boolean,
            default: undefined,
            kComposite: 'shapeDefaults.editable.remove'
        }, 
        shapeDefaultsEditableTools: {
            type: Array,
            default: undefined,
            kComposite: 'shapeDefaults.editable.tools'
        },         shapeDefaultsFill: {
            type: String,
            default: undefined,
            kComposite: 'shapeDefaults.fill'
        }, 
        shapeDefaultsFillColor: {
            type: String,
            default: undefined,
            kComposite: 'shapeDefaults.fill.color'
        }, 
        shapeDefaultsFillOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'shapeDefaults.fill.opacity'
        }, 
        shapeDefaultsFillGradientType: {
            type: String,
            default: undefined,
            kComposite: 'shapeDefaults.fill.gradient.type'
        }, 
        shapeDefaultsFillGradientCenter: {
            type: Array,
            default: undefined,
            kComposite: 'shapeDefaults.fill.gradient.center'
        }, 
        shapeDefaultsFillGradientRadius: {
            type: Number,
            default: undefined,
            kComposite: 'shapeDefaults.fill.gradient.radius'
        }, 
        shapeDefaultsFillGradientStart: {
            type: Array,
            default: undefined,
            kComposite: 'shapeDefaults.fill.gradient.start'
        }, 
        shapeDefaultsFillGradientEnd: {
            type: Array,
            default: undefined,
            kComposite: 'shapeDefaults.fill.gradient.end'
        }, 
        shapeDefaultsFillGradientStops: {
            type: Array,
            default: undefined,
            kComposite: 'shapeDefaults.fill.gradient.stops'
        },         shapeDefaultsHeight: {
            type: Number,
            default: undefined,
            kComposite: 'shapeDefaults.height'
        }, 
        shapeDefaultsHoverFill: {
            type: String,
            default: undefined,
            kComposite: 'shapeDefaults.hover.fill'
        }, 
        shapeDefaultsHoverFillColor: {
            type: String,
            default: undefined,
            kComposite: 'shapeDefaults.hover.fill.color'
        }, 
        shapeDefaultsHoverFillOpacity: {
            type: Number,
            default: undefined,
            kComposite: 'shapeDefaults.hover.fill.opacity'
        }, 
        shapeDefaultsMinHeight: {
            type: Number,
            default: undefined,
            kComposite: 'shapeDefaults.minHeight'
        }, 
        shapeDefaultsMinWidth: {
            type: Number,
            default: undefined,
            kComposite: 'shapeDefaults.minWidth'
        }, 
        shapeDefaultsPath: {
            type: String,
            default: undefined,
            kComposite: 'shapeDefaults.path'
        }, 
        shapeDefaultsRotationAngle: {
            type: Number,
            default: undefined,
            kComposite: 'shapeDefaults.rotation.angle'
        }, 
        shapeDefaultsSelectable: {
            type: Boolean,
            default: undefined,
            kComposite: 'shapeDefaults.selectable'
        }, 
        shapeDefaultsSource: {
            type: String,
            default: undefined,
            kComposite: 'shapeDefaults.source'
        }, 
        shapeDefaultsStrokeColor: {
            type: String,
            default: undefined,
            kComposite: 'shapeDefaults.stroke.color'
        }, 
        shapeDefaultsStrokeDashType: {
            type: String,
            default: undefined,
            kComposite: 'shapeDefaults.stroke.dashType'
        }, 
        shapeDefaultsStrokeWidth: {
            type: Number,
            default: undefined,
            kComposite: 'shapeDefaults.stroke.width'
        }, 
        shapeDefaultsType: {
            type: String,
            default: undefined,
            kComposite: 'shapeDefaults.type'
        }, 
        shapeDefaultsVisual: {
            type: Function,
            default: undefined,
            kComposite: 'shapeDefaults.visual'
        }, 
        shapeDefaultsWidth: {
            type: Number,
            default: undefined,
            kComposite: 'shapeDefaults.width'
        }, 
        shapeDefaultsX: {
            type: Number,
            default: undefined,
            kComposite: 'shapeDefaults.x'
        }, 
        shapeDefaultsY: {
            type: Number,
            default: undefined,
            kComposite: 'shapeDefaults.y'
        }
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-diagram-vue-wrapper/src/KendoDiagram/ShapeDefaults.js